import { GameState, Milestone } from '../domain/types.ts';

interface MilestoneRule {
  id: string;
  emoji: string;
  message: string;
  check: (state: GameState) => boolean;
}

const MILESTONE_RULES: MilestoneRule[] = [
  { id: 'first_sale', emoji: '🥤', message: 'Giao dịch đầu tiên! Sự nghiệp bắt đầu rồi!', check: (s) => s.player.totalSales === 1 },
  { id: 'sales_10', emoji: '🎉', message: 'Đã bán 10 đơn! Khách hàng đang yêu thích quán!', check: (s) => s.player.totalSales === 10 },
  { id: 'sales_50', emoji: '🏅', message: '50 đơn! Quán cóc của bạn đang nổi tiếng!', check: (s) => s.player.totalSales === 50 },
  { id: 'sales_100', emoji: '🏆', message: 'Bán 100 đơn! Bạn là truyền thuyết vỉa hè!', check: (s) => s.player.totalSales === 100 },
  {
    id: 'first_profit',
    emoji: '💰',
    message: 'Ngày đầu có lời! Sự nghiệp bắt đầu khởi sắc!',
    check: (s) => s.dayHistory.length === 1 && (s.dayHistory[0]?.profit ?? 0) > 0,
  },
  {
    id: 'rich_50k',
    emoji: '💵',
    message: 'Tài khoản vượt 500.000đ! Vốn tích lũy tốt!',
    check: (s) => s.player.money >= 500_000 && s.player.totalSales >= 5,
  },
  { id: 'day_3', emoji: '📅', message: 'Ngày thứ 3! Bạn đã trụ vững trên vỉa hè!', check: (s) => s.dayNumber === 3 },
  {
    id: 'first_upgrade',
    emoji: '⬆️',
    message: 'Nâng cấp đầu tiên! Quán ngày càng chuyên nghiệp!',
    check: (s) => Object.keys(s.player.upgrades).length === 1,
  },
  {
    id: 'rainy_day',
    emoji: '🌧️',
    message: 'Bán hàng dưới mưa! Bạn thật kiên cường!',
    check: (s) => s.weather?.type === 'rainy' && s.dayStats.salesCount >= 3,
  },
];

// Track milestones đã kích hoạt (trong memory — không cần persist)
const triggeredIds = new Set<string>();

export class MilestoneSystem {
  public static check(state: GameState): Milestone | null {
    for (const rule of MILESTONE_RULES) {
      if (!triggeredIds.has(rule.id) && rule.check(state)) {
        triggeredIds.add(rule.id);
        return { id: rule.id, message: rule.message, emoji: rule.emoji };
      }
    }
    return null;
  }

  public static reset(): void {
    triggeredIds.clear();
  }
}
